if (!customElements.get('dyefor-announcements')) {
  customElements.define('dyefor-announcements', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.dyefor-announcements__viewport');
      this.track = this.querySelector('.dyefor-announcements__track');
      this.group = this.querySelector('.dyefor-announcements__group');
      this.button = this.querySelector('.dyefor-announcements__toggle');
      this.section = this.closest('.shopify-section');
      if (!this.group?.children.length) return;

      this.events = new AbortController();
      const signal = this.events.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.button?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updatePlayback();
      }, { signal });
      this.motion.addEventListener('change', () => {
        this.paused = this.motion.matches;
        this.updatePlayback();
      }, { signal });
      this.viewport.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!this.viewport.matches(':focus-within') && !this.paused) this.viewport.scrollLeft = 0;
        });
      }, { signal });
      window.addEventListener('scroll', () => this.section.classList.toggle('is-scrolled', scrollY > 24), { passive: true, signal });
      document.addEventListener('visibilitychange', () => this.toggleAttribute('data-document-hidden', document.hidden), { signal });
      document.addEventListener('shopify:block:select', event => {
        const item = [...this.group.children].find(el => el.dataset.blockId === event.detail?.blockId);
        if (!item) return;
        this.paused = true;
        this.updatePlayback();
        this.viewport.scrollLeft = item.offsetLeft;
      }, { signal });
      document.addEventListener('shopify:section:load', () => this.matchHero(), { signal });
      this.section.classList.toggle('is-scrolled', scrollY > 24);
      this.toggleAttribute('data-document-hidden', document.hidden);
      this.matchHero();
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.viewport);
      this.observer.observe(this.group);
      this.measure();
      this.updatePlayback();
    }

    matchHero() {
      if (!document.body.classList.contains('template-index')) return;
      const hero = document.querySelector('.dyefor-personal-hero-band');
      if (!hero) return;
      const style = getComputedStyle(hero);
      const channels = style.backgroundColor.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      if (channels) document.body.style.setProperty('--dyefor-announcement-surface', channels.slice(1).join(', '));
      document.body.style.setProperty('--dyefor-announcement-ink', style.color);
    }

    measure() {
      const width = this.group.getBoundingClientRect().width;
      const viewportWidth = this.viewport.clientWidth;
      const barWidth = this.clientWidth;
      if (!width || !viewportWidth || !barWidth || (width === this.groupWidth && viewportWidth === this.viewportWidth)) return;
      this.groupWidth = width;
      this.viewportWidth = viewportWidth;
      this.track.querySelectorAll('[data-announcement-copy]').forEach(el => el.remove());
      // Repeat the measured group, so the loop has no gap at any viewport width.
      for (let i = 0; i < Math.ceil(viewportWidth / width) + 1; i++) {
        const copy = this.group.cloneNode(true);
        copy.setAttribute('data-announcement-copy', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.removeAttribute('role');
        copy.querySelectorAll('[data-block-id], [data-shopify-editor-block]').forEach(el => {
          el.removeAttribute('data-block-id');
          el.removeAttribute('data-shopify-editor-block');
        });
        copy.querySelectorAll('a').forEach(el => el.tabIndex = -1);
        this.track.append(copy);
      }
      this.style.setProperty('--announcement-distance', `${width}px`);
      // Keep the measured repeat seamless while matching the responsive marquee pace.
      const responsiveFactor = 1 + (Math.min(1600, barWidth) - 375) / 1225;
      this.style.setProperty('--announcement-duration', `${6 * responsiveFactor * width / barWidth}s`);
      if (this.button) this.button.hidden = this.group.children.length < 2;
      this.updatePlayback();
    }

    updatePlayback() {
      const running = !this.paused && this.group.children.length > 1;
      this.toggleAttribute('data-running', running);
      this.toggleAttribute('data-paused', !running);
      const label = running ? 'Pause announcements' : 'Play announcements';
      if (this.button) {
        this.button.setAttribute('aria-label', label);
        this.button.title = label;
      }
      this.viewport.scrollLeft = 0;
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}
